/* Index Top Hero Slideshow.

   The section only adds .Hero_slider_new when it has more than one block, so a
   single-block hero (the science, blog and our-story pages all use one) never
   loads Swiper and renders as plain markup.

   Swiper 11.2.10 is already loaded globally from snippets/scripts.liquid. */

const HERO_ITEMS_SEL = '.Hero_loops_innerblock_innerdetail_mainitems_new';

function syncDots(swiper) {
  const pagination = swiper.pagination && swiper.pagination.el;
  const slide = swiper.slides && swiper.slides[swiper.activeIndex];
  if (!pagination || !slide) return;

  pagination.style.setProperty('--hero-dot-color', getComputedStyle(slide).color);
}

/* Swiper stretches every slide to the height of the tallest one, so a slide
   with shorter copy carries the difference as empty space UNDER its content and
   its button sits that much higher than the tall slide's. Measured at 390 that
   was 41px between "Tabula Rasa 2.0" (one line, 42px) and "Glycolide Lipid
   Repair" (two lines, 83px), and the dots moved with the button.

   Hand each slide its own shortfall to the CSS, which spends it as margin ABOVE
   the button, mobile only. The space then opens between the paragraph and the
   button: headlines stay top-aligned, buttons land on the same line on every
   slide, and the dots hold a constant offset. Desktop already bottom-aligns the
   text column, so the declaration lives inside the 749px media query and this
   var is simply unread above it.

   The var is cleared before measuring. After a pass the heights match, so
   measuring the adjusted state would read every shortfall as zero and collapse
   the fix on the next resize. */
function pinButtons(swiper) {
  const slides = swiper.slides || [];
  let i;

  for (i = 0; i < slides.length; i++) {
    slides[i].style.removeProperty('--hero-slide-slack');
  }

  const heights = [];
  let tallest = 0;
  for (i = 0; i < slides.length; i++) {
    const el = slides[i].querySelector(HERO_ITEMS_SEL);
    const h = el ? el.getBoundingClientRect().height : null;
    heights.push(h);
    if (h !== null && h > tallest) tallest = h;
  }

  for (i = 0; i < slides.length; i++) {
    if (heights[i] === null) continue;
    /* Not rounded to whole px. The natural heights are fractional, so rounding
       the shortfall left the two buttons 1px apart instead of exactly level. */
    const slack = Math.max(0, tallest - heights[i]);
    slides[i].style.setProperty('--hero-slide-slack', slack.toFixed(2) + 'px');
  }
}

function syncHero(swiper) {
  syncDots(swiper);
  pinButtons(swiper);
}

/* Read once. This is the only place it is needed and a single constant keeps the
   Swiper options object readable. */
const REDUCE_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

document.querySelectorAll('.Hero_slider_new').forEach((el) => {

  if (el.classList.contains('swiper-initialized')) return;

  new Swiper(el, {
    loop: true,
    speed: 700,
    autoplay: REDUCE_MOTION ? false : {
      delay: 7000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    grabCursor: true,
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    watchOverflow: true,
    watchSlidesProgress: true,
    threshold: 10,
    autoHeight: false,

    /* Deliberately off. The hero is the first thing under the header, so a
       mousewheel handler here would hijack the page scroll on the way down. */
    mousewheel: false,

    keyboard: { enabled: true, onlyInViewport: true },

    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      paginationBulletMessage: 'Go to slide {{index}}'
    },

    observer: true,
    observeParents: true,

    /* Scoped to this slider. A bare ".swiper-pagination" selector matches
       document-wide and grabs the first one in the DOM rather than its own. */
    pagination: {
      el: el.querySelector('.Hero_pagination_new'),
      clickable: true
    },

    /* The dots live outside the slides, so they cannot inherit the active
       slide's text colour. syncDots hands it across: navy over the pale Tabula
       Rasa artwork, white over the near-black Glycolide artwork. pinButtons is
       the separate, per-slide measurement described above it. Both have CSS
       fallbacks (navy, 0px), so a slider whose slides set no colour and whose
       copy is evenly matched needs nothing from here. */
    on: {
      init(swiper) {
        syncHero(swiper);
        /* The shortfall is a text measurement, so it is wrong until the
           webfonts are in. Without this the first paint can pin the buttons to
           fallback-font heights and leave them a few px apart. */
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => pinButtons(swiper));
        }
      },
      /* Colour only. Re-measuring mid-transition would clear and reset the
         margin while the slide is moving, which reads as a jump. */
      slideChange: syncDots,
      /* The shortfall is a measurement, so it has to be retaken whenever the
         breakpoint or the slide heights move. */
      resize: syncHero,
      update: syncHero
    }

    /* Cycles on its own, and a swipe, dot or arrow key still takes over at any
       time. disableOnInteraction:false is what lets it resume after you touch it
       instead of stopping for good, and pauseOnMouseEnter stops it sliding out
       from under a cursor that is reading the slide. 7s is paced for a hero with
       a headline and a button on it, not for a gallery. Anyone who has asked
       their system to reduce motion gets a static first slide. */
  });

});
